import React from 'react';

// Styles & Assets
import styles from './BarArrows.module.css';
import { ReactComponent as ArrowLeftSVG } from '../../../assets/icons/arrow-left.svg';

// Services
import { getMonthsYear } from '../../../services/getPollAttribute';

// Hooks
import { useTranslation } from 'react-i18next';

// Other
import moment from 'moment';

// Interfaces
interface Props {
    isViewMonthly: boolean
    referenceDate: moment.Moment
    setReferenceDate: React.Dispatch<React.SetStateAction<moment.Moment>>
}

const BarArrows: React.FC<Props> = ({ isViewMonthly, referenceDate, setReferenceDate }) => {

    const { t } = useTranslation();

    const formatDDMMYYYY = 'DD-MM-YYYY';
    const setDateDDMMYYYY = (day: number, month: number, year: number) =>
        moment({ date: day, month, year });

    const handleBack = () => {
        if (isViewMonthly)
            setReferenceDate(oldDate => {
                const year = oldDate.year();
                const previousMonth = oldDate.month() - 1;
                return moment(
                    previousMonth < 0 ? setDateDDMMYYYY(1, 11, year - 1) : setDateDDMMYYYY(1, previousMonth, year),
                    formatDDMMYYYY
                );
            });
        else setReferenceDate(oldDate => oldDate.clone().subtract(7, 'd'));
    };

    const handleNext = () => {
        if (isViewMonthly)
            setReferenceDate(oldDate => {
                const year = oldDate.year();
                const nextMonth = oldDate.month() + 1;
                return nextMonth > 11 ? setDateDDMMYYYY(1, 0, year + 1) : setDateDDMMYYYY(1, nextMonth, year);
            });
        else setReferenceDate(oldDate => oldDate.clone().add(7, 'd'));
    };


    const getLabelMonth = (monthNum: number) =>
        t(getMonthsYear().find(m => m.id === monthNum)?.label ?? '');

    const parseViewWeekText = () => {
        if (isViewMonthly) return `${getLabelMonth(referenceDate.month())} ${referenceDate.year()}`;
        const firstDayWeek = referenceDate.clone().startOf('isoWeek');
        const endDayWeek = firstDayWeek.clone().add(4, 'd');
        const areSameMonth = firstDayWeek.month() === endDayWeek.month();
        const endDayText = `${endDayWeek.date()} ${getLabelMonth(endDayWeek.month())} ${endDayWeek.year()}`;
        if (areSameMonth) return `${firstDayWeek.date()}-${endDayText}`;
        const areSameYear = firstDayWeek.year() === endDayWeek.year();
        if (areSameYear) return `${firstDayWeek.date()} ${getLabelMonth(firstDayWeek.month())}-${endDayText}`;
        return `${firstDayWeek.date()} ${getLabelMonth(firstDayWeek.month())} ${firstDayWeek.year()}-${endDayText}`;
    };

    return (
        <div className={styles.sliderMonth}>
            <button className={styles.arrow} onClick={handleBack}>
                <ArrowLeftSVG />
            </button>
            <p className={styles.month} style={{ width: isViewMonthly ? 220 : 380 }}>
                {parseViewWeekText()}
            </p>
            <button className={styles.arrow} onClick={handleNext}>
                <ArrowLeftSVG className={styles.arrowRight} />
            </button>
        </div>
    );
};

export default BarArrows;